// extracted by mini-css-extract-plugin
module.exports = {"section":"DocSection_section__Fwx3p","title":"DocSection_title__829Xu","body":"DocSection_body__B5OUr"};